import { AfterViewChecked, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { PlatformService } from 'lib/platform/platform.service.js';
import { BehaviorSubject } from 'rxjs';
import { guidHelper } from '../../helpers/guid-helper.class.js';

export interface ITooltipMenuItem {
	title: string;
	routerLink?: string;
	click?: () => void;
}

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'lib-tooltip-menu',
	templateUrl: 'tooltip-menu.component.html',
	standalone: false
})
export class TooltipMenuComponent implements AfterViewChecked {
	@ViewChild('content') content?: ElementRef;
	@ViewChild('wrapper') wrapper?: ElementRef;

	public readonly guid: string = `tooltipMenu_${guidHelper.newGuid()}`;
	public readonly contentLoaded_ = new BehaviorSubject<HTMLElement | undefined>(undefined);

	constructor(private readonly platformService: PlatformService) {}

	/**
	 * Using ngAfterViewChecked here because the new 'afterRender' event was being run
	 * indefinitely very often. It also causes 'root' component to re-render (add afterRender console.log  to root to see that)
	 */
	ngAfterViewChecked(): void {
		// no need to run this on server
		if (!this.platformService.isBrowser) {
			return;
		}
		const wrapper = this.wrapper;

		if (wrapper) {
			this.contentLoaded_.next(wrapper.nativeElement);
		}
	}

	handleClick(): void {}
}
